// extracted by mini-css-extract-plugin
export default {"container":"CommunityDashboardPage_container__zp58t","header":"CommunityDashboardPage_header__iCR+S","title":"CommunityDashboardPage_title__g0Jfw"};